export default __webpack_public_path__ + "static/media/V720_RoHS.76d953d7.pdf";